module.exports = __webpack_public_path__ + "img/chol_yes.cca52fa8.png";